module.exports = __webpack_public_path__ + "static/media/musio_price_introduction.10acf2da.svg";